import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ContractDigitalAddLotRoutingModule } from "./contract-digital-add-lot-routing.module";
import { MaterialModule } from "src/app/core/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { MatAutocompleteModule, MatInputModule, MatProgressBarModule } from "@angular/material";
import { NgMatAutocompleteModule } from "src/app/shared/components/autocomplete/autocomplete.module";
import { NgxMaskModule } from "ngx-mask";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { NotifyModule } from "../notify/notify.module";
import { HotTableModule } from "@handsontable/angular";
import { AddLotMohaDigitalComponent } from "./add-lot-moha-digital/add-lot-moha-digital.component";
//import { SignatureConfigLotMohaComponent } from './signature-config-lot-moha/signature-config-lot-moha.component';
import { ConfigSigningFlowMohaComponent } from './config-signing-flow-moha/config-signing-flow-moha.component';
//import { WarningDialogMohaComponent } from './warning-dialog-moha/warning-dialog-moha.component';
import { UploadFileDigitalComponent } from './upload-file-digital/upload-file-digital.component'
@NgModule({
  declarations: [
    AddLotMohaDigitalComponent,
    //SignatureConfigLotMohaComponent,
    ConfigSigningFlowMohaComponent,
    //WarningDialogMohaComponent
    UploadFileDigitalComponent
  ],
  imports: [
    CommonModule,
    ContractDigitalAddLotRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MatInputModule,
    NgxMaskModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgZorroAntdModule,
    SlickCarouselModule,
    NotifyModule,
    HotTableModule,
  ],
  exports: [],
  entryComponents: [
    ConfigSigningFlowMohaComponent,
    //WarningDialogMohaComponent,
    AddLotMohaDigitalComponent,
    UploadFileDigitalComponent
  ],
})
export class ContractDigitalAddLotModule {}
